(function () {
  'use strict';

  function debounce(fn, delay) {
    let t;
    return function (...args) {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), delay);
    };
  }

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  // ── Product Gallery (single-item scroll-snap) ──────────────────────────────
  function initProductGallery() {
    const slider = document.querySelector('.product-gallery-slider');
    if (!slider) return;

    const items = Array.from(slider.querySelectorAll(':scope > .item'));
    if (items.length === 0) return;

    const total = items.length;
    const currentEl = document.querySelector('.current-slide');
    const thumbs = document.querySelectorAll('.pdp-thumb');
    const prevBtn = slider.closest('.pdp-gallery__main')?.querySelector('.pgallery-prev');
    const nextBtn = slider.closest('.pdp-gallery__main')?.querySelector('.pgallery-next');

    function getActiveIndex() {
      let closest = 0;
      let minDist = Infinity;
      items.forEach(function (item, i) {
        const dist = Math.abs(item.offsetLeft - slider.scrollLeft);
        if (dist < minDist) {
          minDist = dist;
          closest = i;
        }
      });
      return closest;
    }

    function updateUI(idx) {
      if (currentEl) currentEl.textContent = idx + 1;
      thumbs.forEach(function (thumb, i) {
        thumb.classList.toggle('pdp-thumb--active', i === idx);
        thumb.setAttribute('aria-current', i === idx ? 'true' : 'false');
      });
    }

    function scrollToIndex(idx) {
      const clamped = ((idx % total) + total) % total;
      slider.scrollTo({ left: items[clamped].offsetLeft, behavior: 'smooth' });
    }

    slider.addEventListener('scroll', debounce(function () {
      updateUI(getActiveIndex());
    }, 60));

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        scrollToIndex(getActiveIndex() - 1);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        scrollToIndex(getActiveIndex() + 1);
      });
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        const idx = parseInt(thumb.dataset.index, 10);
        scrollToIndex(idx);
      });
    });
  }

  // ── Product Info List Carousel (horizontal scroll) ─────────────────────────
  function initInfoCarousel() {
    const carousel = document.getElementById('productInfoList');
    if (!carousel) return;

    const items = carousel.querySelectorAll(':scope > .item');
    if (!items.length) return;

    let autoplayTimer = null;
    let isPaused = false;

    function getItemWidth() {
      return items[0].offsetWidth + 10;
    }

    function getVisibleCount() {
      return Math.floor(carousel.clientWidth / getItemWidth());
    }

    function scrollStep() {
      const maxScroll = carousel.scrollWidth - carousel.clientWidth;
      if (carousel.scrollLeft >= maxScroll - 2) {
        carousel.scrollTo({ left: 0, behavior: 'smooth' });
      } else {
        carousel.scrollBy({ left: getItemWidth() * getVisibleCount(), behavior: 'smooth' });
      }
    }

    function startAutoplay() {
      autoplayTimer = setInterval(function () {
        if (!isPaused) scrollStep();
      }, 3000);
    }

    carousel.addEventListener('mouseenter', function () { isPaused = true; });
    carousel.addEventListener('mouseleave', function () { isPaused = false; });
    carousel.addEventListener('touchstart', function () { isPaused = true; }, { passive: true });
    carousel.addEventListener('touchend', function () {
      setTimeout(function () { isPaused = false; }, 1500);
    }, { passive: true });

    startAutoplay();
  }

  // ── Sticky Buy Button ──────────────────────────────────────────────────────
  function initStickyBuyButton() {
    document.addEventListener('click', function (e) {
      if (!e.target.closest('.stickyBuyButton')) return;
      const btn = document.querySelector('shopify-buy-it-now-button button');
      if (btn) btn.click();
    });
  }

  // ── Custom Popup Button ────────────────────────────────────────────────────
  function initCustomPopupButton() {
    document.addEventListener('click', function (e) {
      if (!e.target.closest('.customPopupButton')) return;
      const hideBtn = document.querySelector('.hidePopupButton');
      if (hideBtn) hideBtn.click();
    });
  }

  // ── Filter Availability Auto-sync ──────────────────────────────────────────
  function initFilterSync() {
    document.addEventListener('change', function (e) {
      if (!e.target.matches('.facets-layout-list--text input[type="checkbox"]')) return;
      setTimeout(function () {
        const avail1 = document.getElementById('Filter-filter.v.availability-1');
        const avail2 = document.getElementById('Filter-filter.v.availability-mobile-1');
        if (avail1 && !avail1.checked) {
          avail1.checked = true;
          avail1.dispatchEvent(new Event('change', { bubbles: true }));
        }
        if (avail2 && !avail2.checked) {
          avail2.checked = true;
          avail2.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }, 500);
    });
  }

  ready(function () {
    initProductGallery();
    initInfoCarousel();
    initStickyBuyButton();
    initCustomPopupButton();
    initFilterSync();
  });
})();
